import styled from "styled-components";
import {JBOptInReminderTextContentDefaultBox} from "./jb-optin-reminder-text-content.default.box";

export const JbOptinReminderTextContentCasino777Box = styled(JBOptInReminderTextContentDefaultBox)`
  color: ${props => props.theme.colors.brandSecondaryContrast};
  font-weight: 300;
  line-height: 100%;
  letter-spacing: 0;
  font-size: 1.7rem;
  margin-top: 16px;
`;
